/** @jsx h */
// ═══════════════════════════════════════════════════════
//  Cute Sound Synthesizer (Animal Crossing style)
// ═══════════════════════════════════════════════════════
const audioCtx = typeof window !== 'undefined' 
	? new (window.AudioContext || window.webkitAudioContext)() 
	: null;

let isAudioStarted = false;

function ensureAudio() {
	if (!audioCtx) return false;
	if (!isAudioStarted && audioCtx.state === 'suspended') {
		audioCtx.resume();
		isAudioStarted = true;
	}
	return true;
}

// Initialize audio on first user interaction (browser autoplay policy)
export function initAudio() {
	const handler = () => {
		ensureAudio();
		document.removeEventListener('click', handler);
		document.removeEventListener('touchstart', handler);
	};
	document.addEventListener('click', handler);
	document.addEventListener('touchstart', handler);
}

// Soft bloop — main button clicks
export function playBloop(pitch = 1.0) {
	if (!ensureAudio()) return;
	const now = audioCtx.currentTime;
	const osc = audioCtx.createOscillator();
	const gain = audioCtx.createGain();
	
	osc.type = 'sine';
	osc.frequency.setValueAtTime(600 * pitch + Math.random() * 80, now);
	osc.frequency.exponentialRampToValueAtTime(400 * pitch, now + 0.12);
	
	gain.gain.setValueAtTime(0, now);
	gain.gain.linearRampToValueAtTime(0.12, now + 0.01);
	gain.gain.exponentialRampToValueAtTime(0.001, now + 0.15);
	
	osc.connect(gain);
	gain.connect(audioCtx.destination);
	osc.start(now);
	osc.stop(now + 0.18);
}

// Tiny pop — toggles, switches, small interactions
export function playPop() {
	if (!ensureAudio()) return;
	const now = audioCtx.currentTime;
	const osc = audioCtx.createOscillator();
	const gain = audioCtx.createGain();
	
	osc.type = 'triangle';
	osc.frequency.setValueAtTime(900 + Math.random() * 100, now);
	osc.frequency.exponentialRampToValueAtTime(600, now + 0.06);
	
	gain.gain.setValueAtTime(0, now);
	gain.gain.linearRampToValueAtTime(0.08, now + 0.005);
	gain.gain.exponentialRampToValueAtTime(0.001, now + 0.08);
	
	osc.connect(gain);
	gain.connect(audioCtx.destination);
	osc.start(now);
	osc.stop(now + 0.1);
}

// Sparkly chime — success, copy, celebration
export function playChime() {
	if (!ensureAudio()) return;
	const now = audioCtx.currentTime;
	const notes = [523.25, 659.25, 783.99]; // C5, E5, G5 major triad
	
	notes.forEach((freq, i) => {
		const osc = audioCtx.createOscillator();
		const gain = audioCtx.createGain();
		osc.type = 'sine';
		osc.frequency.setValueAtTime(freq, now + i * 0.06);
		gain.gain.setValueAtTime(0, now + i * 0.06);
		gain.gain.linearRampToValueAtTime(0.1, now + i * 0.06 + 0.02);
		gain.gain.exponentialRampToValueAtTime(0.001, now + i * 0.06 + 0.25);
		osc.connect(gain);
		gain.connect(audioCtx.destination);
		osc.start(now + i * 0.06);
		osc.stop(now + i * 0.06 + 0.3);
	});
}
